module.exports = __webpack_public_path__ + "static/media/smb_powerup_low.e0d824c9.wav";